<script>
import { mapGetters } from 'vuex';
import Base from './base.vue';
import { planTypes, ZOOM_MEETING_EDU_PLUS_MIN_LICENSE, } from '@/common/constants';
import { plansof } from '@/utils/chain';

export default {
  name: 'Upgrade',
  extends: Base,
  computed: {
    ...mapGetters(['boughtPlans', 'migratePlanState']),
    isShowLeastDesc() {
      return !this.migratePlanState.is.esc2escp;
    },
    addRegionVisible() {
      return false
    },
    minCallingPlan() {
      const boughtAmount = plansof(this.boughtPlans).type(planTypes.ZOOM_MEETING).get(0)?.cartInfo?.selected_number ?? 0
      return Math.max(boughtAmount, ZOOM_MEETING_EDU_PLUS_MIN_LICENSE)
    },
    maxCallingPlan() {
      return 9999;
    },
    planDetailLabel() {
      // from pricing page upgrade CTA
      if (this.$context.is.esc2escp) return false;
      return this.$t('billing.plan_details');
    }
  },
}
</script>
